/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const INVOICED = 'Invoiced';
export const NON_INVOICED = 'Non-invoiced';
export const QUARTER = 'Quarter';
export const REBATE_PROGRAM = 'Rebate Program';
export const PLAN_TYPE = 'Plan Type';
export const CMS_MISMATCH_GRID_LABEL = 'CMS Mismatch Detail';
export const navigate = '/cmsMismatch';
